/* eslint-disable */
export const SCOPE = 'data:birdChart';

export const INIT = `${SCOPE}/INIT`;
export const SET_SLICE_INTERVAL = `${SCOPE}/SET_SLICE_INTERVAL`;
export const SET_INVALID_RESPONSE = `${SCOPE}/SET_INVALID_RESPONSE`;
export const RESET_SLICE_INTERVAL = `${SCOPE}/RESET_SLICE_INTERVAL`;
export const SET_SHARING_STATE = `${SCOPE}/SET_SHARING_STATE`;

export const FETCHING = `${SCOPE}/FETCHING`;
export const FETCHING_SUCCESS = `${SCOPE}/FETCHING_SUCCESS`;
export const FETCHING_FAILS = `${SCOPE}/FETCHING_FAILS`;

export const FETCHING_SLICE = `${SCOPE}/FETCHING_SLICE`;
export const FETCHING_SLICE_SUCCESS = `${SCOPE}/FETCHING_SLICE_SUCCESS`;
export const FETCHING_SLICE_FAILS = `${SCOPE}/FETCHING_SLICE_FAILS`;

export const RESET_RESPONSE = `${SCOPE}/RESET_RESPONSE`;

export const SAVE_TRENDS_DIAGNOSTICS_SLICE = `${SCOPE}/SAVE_TRENDS_DIAGNOSTICS_SLICE`;
export const SAVE_TRENDS_DIAGNOSTICS_SLIDER = `${SCOPE}/SAVE_TRENDS_DIAGNOSTICS_SLIDER`;
